/* "Wear it together" — size selection + add to cart for the paired piece.
   Each card is independent: it holds its own variant table, so the abaya's 52–60
   and the linen set's XS–XL never get confused with each other. */
(function () {
  var root = document.querySelector('[data-pair]');
  if (!root) return;

  var PICK_SIZE = root.dataset.pickSize || 'Choose a size';
  var ADDED = root.dataset.added || 'Added to your bag';

  function money(cents) {
    var fmt = (window.THAYA && window.THAYA.money_format) || '{{amount}} AED';
    var v = (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    if (/\{\{\s*amount_no_decimals\s*\}\}/.test(fmt)) {
      v = Math.round(cents / 100).toLocaleString();
      return fmt.replace(/\{\{\s*amount_no_decimals\s*\}\}/, v);
    }
    return fmt.replace(/\{\{\s*amount\s*\}\}/, v);
  }

  function toast(msg) {
    if (window.ThayaToast) window.ThayaToast(msg);
  }

  root.querySelectorAll('[data-pair-card]').forEach(function (card) {
    var json = card.querySelector('[data-mate-variants]');
    var variants = [];
    try { variants = JSON.parse(json.textContent); } catch (e) { return; }

    var addBtn = card.querySelector('[data-pair-add]');
    var priceEl = card.querySelector('[data-mate-price]');
    var sizeBtns = [].slice.call(card.querySelectorAll('[data-size-value]'));
    var chosen = null;

    // Grey out sizes with no stock so nobody picks a dead variant
    sizeBtns.forEach(function (b) {
      if (b.hasAttribute('data-custom-fit')) return;
      var v = variants.filter(function (x) {
        return (x.options || []).indexOf(b.dataset.sizeValue) !== -1;
      })[0];
      if (v && !v.available) b.disabled = true;
    });

    function needSize(on) {
      addBtn.classList.toggle('is-need-size', on);
      addBtn.textContent = on ? PICK_SIZE : addBtn.dataset.labelAdd;
    }
    addBtn.dataset.labelAdd = addBtn.textContent.trim();
    if (sizeBtns.length) needSize(true);

    sizeBtns.forEach(function (b) {
      b.addEventListener('click', function () {
        // Made-to-measure needs the full measurement form — send them to the product page
        if (b.hasAttribute('data-custom-fit')) {
          window.location.href = b.dataset.mateUrl;
          return;
        }
        sizeBtns.forEach(function (x) { x.classList.remove('is-active'); });
        b.classList.add('is-active');
        chosen = variants.filter(function (x) {
          return (x.options || []).indexOf(b.dataset.sizeValue) !== -1 && x.available;
        })[0] || null;
        if (chosen && priceEl) priceEl.textContent = money(chosen.price);
        needSize(!chosen);
      });
    });

    addBtn.addEventListener('click', function () {
      if (sizeBtns.length && !chosen) {
        toast(PICK_SIZE);
        var first = card.querySelector('[data-size-value]:not(:disabled)');
        if (first) first.focus();
        return;
      }
      var id = chosen ? chosen.id : parseInt(addBtn.dataset.defaultId, 10);
      if (!id) return;

      addBtn.disabled = true;
      var route = (window.THAYA && window.THAYA.routes && window.THAYA.routes.cart_add) || '/cart/add.js';
      fetch(route, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
      })
        .then(function (r) { return r.json(); })
        .then(function () {
          if (window.ThayaCart && window.ThayaCart.refresh) {
            return window.ThayaCart.refresh().then(function () {
              if (window.ThayaCart.open) window.ThayaCart.open();
            });
          }
          toast(ADDED);
        })
        .catch(function () { toast(PICK_SIZE); })
        .then(function () { addBtn.disabled = false; });
    });
  });
})();
